import * as React from 'react';
import { MultiImagePickerProps } from './MultiImagePicker';

function getRandom(base: number, variance: number) {
    return (Math.random() - 0.5) * variance + base;
}

export function useCatMultiImagePicker(): MultiImagePickerProps<{ id: number; src: string; title: string }> {
    const [value, setValue] = React.useState(0);
    const [items, setItems] = React.useState<Array<{ id: number; src: string; title: string }>>([]);

    const onAddNew = React.useCallback(() => {
        const num = getRandom(150, 25);
        const src = `https://cataas.com/c?width=${num}&height=${num}`;
        setItems(prev => [
            ...prev,
            {
                id: prev.length,
                src,
                title: `Cat ${num}`,
            },
        ]);
    }, []);

    const onChange = React.useMemo(() => setValue, []);

    const onRemove = React.useCallback(
        (id: number | string) => setItems(prev => prev.filter(item => item.id !== id)),
        [],
    );

    const onDrop = React.useCallback((from: number | string, to: number | string) => {
        setItems(prev => {
            const fromIdx = prev.findIndex(buh => buh.id === from);
            const toIdx = prev.findIndex(buh => buh.id === to);
            const [item] = prev.splice(fromIdx, 1);
            return [...prev.slice(0, toIdx), item, ...prev.slice(toIdx)];
        });
    }, []);

    const disableRemove = React.useMemo(() => items.length < 2, [items.length]);

    React.useEffect(() => {
        setValue(items.length - 1);
    }, [items.length]);

    return {
        disableRemove,
        items,
        onAddNew,
        onChange,
        onDrop,
        onRemove,
        value,
    };
}
